// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1-_T9","title":"AfterBackImages_title__3zsF8","images":"AfterBackImages_images__2is7o"};